<template>
  <BaseButton
    :loading="isSaving"
    :disabled="isSaving"
    class="mt-4"
    @click="handleSave"
    >Save</BaseButton
  >
</template>

<script>
import Vue from 'vue'
import { defineComponent, inject, ref } from '@vue/composition-api'

import { CompanyService } from '@services'
import { BaseButton } from '@components/base'

export default defineComponent({
  name: 'CompanyRLSGroupChecklistSaveButton',
  components: {
    BaseButton
  },
  setup() {
    const { rlsGroup, company, setCompany, modalRef } =
      inject('company-rls-group')
    const { selected } = inject('company-rls-group-checklist')

    const isSaving = ref(false)

    const handleSave = async () => {
      isSaving.value = true

      try {
        const { data } = await CompanyService.put(
          company.value.id,
          {
            ...company.value,
            role_id: company.value.role.id,
            [`rls_${rlsGroup.value.toLowerCase()}_ids`]: selected.value
          },
          {
            transformResponse: [
              (res) => {
                return {
                  ...JSON.parse(res),
                  noToastError: true
                }
              }
            ]
          }
        )
        const { data: results } = data || {}

        isSaving.value = false

        setCompany(results.data)

        if (!!modalRef.value) {
          modalRef.value.$bvModal.hide(
            `company-rls-group-modal-${rlsGroup.value}`
          )
        }

        Vue.prototype.$toasted.show(
          `Company ${rlsGroup.value} updated successfully!`
        )
      } catch (e) {
        const res = JSON.parse(e.response.data)
        const { data } = res || {}
        const { error, message } = data || {}

        if (!!error) {
          const { default_report_id } = error || {}

          if (!!default_report_id) {
            Vue.prototype.$toasted.show('Default report ID cannot be null.', {
              type: 'error'
            })
          } else {
            Vue.prototype.$toasted.show(e.message, { type: 'error' })
          }
        } else {
          Vue.prototype.$toasted.show(message, { type: 'error' })
        }

        isSaving.value = false
      }
    }

    return {
      isSaving,

      handleSave
    }
  }
})
</script>
